
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bookpunetoaurangabadcab() {



    const cardData =
    {
        keyword: 'Pune to Aurangabad Taxi Services',
        heading: 'S9 Travels: Pune to Aurangabad Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Aurangabad. Whether you are visiting for historical exploration, a cultural experience, or to see the famous Ajanta and Ellora Caves, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Aurangabad is approximately 230 km from Pune, and the journey takes around 4.5 to 5 hours by road. Enjoy a safe, comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Aurangabad with S9 Travels',

"topPlaces": [
    {
        "title": "Ajanta Caves",
        "description": "A UNESCO World Heritage Site, the Ajanta Caves are one of the most famous historical and cultural landmarks in India. These ancient rock-cut caves, dating back to the 2nd century BCE, are known for their exquisite murals, paintings, and Buddhist architecture. A must-visit for history and art lovers!"
    },
    {
        "title": "Ellora Caves",
        "description": "Another UNESCO World Heritage Site, the Ellora Caves are a complex of 34 monasteries and temples carved into the cliffs of the Sahyadri Hills. The caves are known for their intricate sculptures and carvings, with the Kailasa Temple being the highlight. The Ellora Caves represent a unique blend of Hindu, Buddhist, and Jain architecture."
    },
    {
        "title": "Bibi Ka Maqbara",
        "description": "Often referred to as the 'Taj of the Deccan,' Bibi Ka Maqbara is a stunning Mughal mausoleum built in memory of Begum Rabia Durrani, the wife of Aurangzeb. The monument features beautiful Mughal architecture and gardens and is a must-visit for those interested in history and architecture."
    },
    {
        "title": "Aurangabad Caves",
        "description": "The Aurangabad Caves are a group of 12 rock-cut Buddhist shrines located on a hill near the city. These caves are known for their intricate sculptures, beautiful carvings, and serene atmosphere, making them a peaceful place to explore and learn about ancient Buddhist history."
    },
    {
        "title": "Daulatabad Fort",
        "description": "Daulatabad Fort, also known as Devgiri Fort, is a historic hill fort located around 15 km from Aurangabad. The fort is known for its impressive structure, strategic location, and the fort's unique architectural features like a series of intricate defense mechanisms. The view from the top is breathtaking."
    },
    {
        "title": "Panchakki",
        "description": "Panchakki, also known as the Water Mill, is an important historical site in Aurangabad. It was built in the 17th century to harness the power of water for grinding grains. The site features a functioning water mill and a serene garden, making it a peaceful place to visit."
    },
    {
        "title": "Grishneshwar Temple",
        "description": "One of the 12 Jyotirlingas of Lord Shiva, Grishneshwar Temple is located near Ellora and is an important pilgrimage site for Hindus. The temple's beautiful architecture and spiritual significance make it a must-visit for devotees and those interested in history."
    },
    {
        "title": "Siddharth Garden and Zoo",
        "description": "If you're traveling with family or seeking a peaceful day out, Siddharth Garden and Zoo is an excellent spot. The garden has lush greenery, a zoo with a variety of animals, and a children's park, making it an ideal place to relax and enjoy nature."
    },
    {
        "title": "Jami Masjid",
        "description": "Located in the heart of Aurangabad, the Jami Masjid is an important architectural and religious site. The mosque is known for its grand structure and peaceful atmosphere. It is a significant landmark in the city, showcasing Islamic architectural styles."
    },
    {
        "title": "Shirdi",
        "description": "While not in Aurangabad itself, Shirdi is located about 110 km away and is a major pilgrimage destination for devotees of Sai Baba. The Shirdi Sai Baba Temple attracts millions of visitors every year, and it’s a short trip from Aurangabad, making it a great addition to your itinerary."
    }
],

"services": [
  {
    "name": "Pune to Aurangabad Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Aurangabad. Whether you’re traveling for business, leisure, or to explore historical sites, enjoy a smooth and hassle-free ride. Book your Pune to Aurangabad taxi today!"
  },
  {
    "name": "Pune to Aurangabad Cab Service",
    "description": "Choose S9 Travels for a professional and reliable cab service from Pune to Aurangabad. Our experienced drivers and well-maintained vehicles ensure a comfortable and enjoyable journey, making your trip a memorable one."
  },
  {
    "name": "Pune to Aurangabad One-Way Taxi",
    "description": "S9 Travels offers affordable and convenient one-way taxi services for your journey from Pune to Aurangabad. Travel directly to your destination with comfort and ease, without the hassle of returning. Book your one-way trip today!"
  },
  {
    "name": "Pune to Aurangabad Round Trip",
    "description": "For a round trip from Pune to Aurangabad, S9 Travels offers flexible options. We ensure that your journey is comfortable, timely, and stress-free, with professional drivers and quality vehicles to make your round trip enjoyable."
  },
  {
    "name": "Pune to Aurangabad Cab Fare",
    "description": "S9 Travels provides transparent and affordable cab fares for your Pune to Aurangabad journey. We ensure great value for your money, with no hidden charges. Contact us for an accurate fare estimate and plan your trip without any surprises."
  },
  {
    "name": "Pune to Aurangabad Car Rental",
    "description": "Looking to rent a car for your trip from Pune to Aurangabad? S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a variety of vehicles that best suit your travel needs."
  },
  {
    "name": "Pune to Aurangabad Luxury Taxi",
    "description": "For a luxurious and comfortable travel experience, S9 Travels offers premium luxury taxi services from Pune to Aurangabad. Enjoy a smooth, stylish, and relaxing ride with enhanced comfort and extra space in our top-class vehicles."
  },
  {
    "name": "Pune to Aurangabad Efficient Taxi",
    "description": "S9 Travels provides Efficient Taxi services for those looking for a more budget-friendly travel option. Share the ride with others and enjoy a comfortable and convenient journey from Pune to Aurangabad at an affordable price."
  }
],


"tableData": [
  ["Book Pune To Aurangabad Taxi", "Book Pune To Aurangabad Cab Service"],
  ["Book Pune To Aurangabad One-Way Taxi", "Book Pune To Aurangabad Round Trip"],
  ["Book Pune To Aurangabad Cab Fare", "Book Pune To Aurangabad Car Rental"],
  ["Book Pune To Aurangabad Luxury Taxi", "Book Pune To Aurangabad Efficient Taxi"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand how important your time is when traveling from Pune to Aurangabad. Whether you’re visiting for business, religious purposes, or leisure, we guarantee timely pickups and drop-offs, ensuring a hassle-free trip."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a fleet of comfortable and well-maintained vehicles for your journey to Aurangabad. Our cars are equipped with air conditioning, spacious seating, and modern amenities to provide a smooth and relaxing ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced in long-distance travel and are familiar with the best routes to Aurangabad. Their professionalism ensures a safe, smooth, and comfortable journey every time, allowing you to sit back and relax."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Aurangabad trip. We provide a clear breakdown of all charges upfront with no hidden costs, so you can plan your journey with confidence."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking to ensure a secure and comfortable ride from Pune to Aurangabad."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates around the clock, so whether you're planning an early morning trip or a late-night return, we are always available to cater to your needs. Our customer service team is also available to assist you at any time."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Aurangabad cab with S9 Travels is easy and convenient. You can book through our website, mobile app, or contact our customer service team for personalized assistance."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you’re visiting Aurangabad for sightseeing, business, or religious reasons, we offer customized travel packages to meet your needs. Let us know your preferences, and we’ll tailor the trip to ensure it’s as enjoyable and convenient as possible."
  }
]














    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Aurangabad cab with S9 Travels?',
            answer: 'Booking a cab is simple! You can easily book online through our website or app, or contact our customer service team for any help with your reservation.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are highly skilled and experienced in long-distance travel, ensuring a smooth, safe, and comfortable journey to Aurangabad.',
          },
          {
            question: 'What types of vehicles are available for Pune to Aurangabad travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars, all well-maintained and designed for comfort on long trips.',
          },
          {
            question: 'How do I pay for my Pune to Aurangabad cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it convenient for you to pay.',
          },
          {
            question: 'Can I book a round trip from Pune to Aurangabad?',
            answer: 'Yes, we offer round-trip services. Simply provide us with your return details, and we’ll make all the necessary arrangements for your return journey.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Aurangabad?',
            answer: 'Yes, we offer sightseeing tours in Aurangabad, including visits to popular attractions like the Ellora Caves, Ajanta Caves, Bibi Ka Maqbara, and more. Our experienced drivers will guide you through these iconic spots.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Aurangabad cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have extra luggage or specific requirements, please inform us during the booking process, and we will make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Aurangabad?',
            answer: 'Yes, we offer corporate travel services for business trips or team outings between Pune and Aurangabad. We ensure punctual, professional, and comfortable service for corporate clients.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Aurangabad travel?',
            answer: 'With S9 Travels, you get a reliable, comfortable, and affordable journey. Our professional drivers, well-maintained vehicles, and excellent customer service ensure a safe, smooth, and enjoyable trip every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rajesh Patel',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“I had a fantastic experience with S9 Travels for my trip to Aurangabad. The vehicle was clean and comfortable, and the driver was professional and friendly. The trip was smooth and hassle-free, and I’ll definitely book again!”',
        },
        {
          name: 'Mrs. Meenal Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“Our family had a wonderful trip to Aurangabad with S9 Travels. The vehicle was spacious, and the driver was knowledgeable about the area, making our sightseeing tour even better. Highly recommend them!”',
        },
      ];
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Aurangabad Cab",
        "description": "Book Pune To Aurangabad taxi services, one-way taxi, round trip, luxury taxi, Efficient Taxi, and car rental with S9 Travels. Choose from affordable Pune to Aurangabad cab booking options for a comfortable and safe journey with professional drivers.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
      


    return (
        <div>
         
      <Helmet>
        <title>Book Pune To Aurangabad Cab | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune To Aurangabad taxi services, one-way taxi, round trip, luxury taxi, Efficient Taxi, and car rental with S9 Travels. Get the best fares for Pune to Aurangabad cab booking, ensuring a safe and comfortable ride." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/9.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookpunetoaurangabadcab;